import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { RevenueManagerAPIService } from '../../../../api';
import { getDateRange } from "../../../../utils/common-methods";

export const revenueManagerResolver: ResolveFn<any> = () => {
  const dateRange = getDateRange(new Date().toISOString().split('T')[0]);

  const activationDates = [
    dateRange.startDate,
    dateRange.endDate
  ];

  return inject(RevenueManagerAPIService).getFiltersData({
    filters: {
      ACTIVATION_DATE: activationDates,
    } as any,
  });
};
